import { BaseService } from '../../infra/base.service'
import type { CategoriesRepository } from './categories.repository'
import type { Category } from './category'

export class CategoriesService extends BaseService<Category> {
    constructor(private rep: CategoriesRepository) {
        super(rep)
    }
}
